import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { protectedRoutes } from "./routes";
import { PageNotFound } from "./global/components/PageNotFound";
import Login from "./global/auth/Login";
import { PrivateRoute } from "./global/components/PrivateRoute";
import { ConfigProvider } from "antd";
import AutoLogout from "./global/auth/AutoLogout";
import useOemData from "./global/hooks/useOemData";
import BlockPage from "./modules/MySite/Page/BlockPage";

function App() {
  const { oemNo, oemData, loading: oemDataLoading } = useOemData();

  function hexToRGBA(hex, opacity) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  useEffect(() => {
    document.title = oemData ? `Cloud | ${oemData?.name}` : "Cloud | Server";
    const favicon = document.getElementById("favicon");
    const faviconPath = oemNo && require(`./oem/${oemNo}/favicon.ico`);
    if (faviconPath) {
      favicon.href = faviconPath;
    }
  }, [oemNo, oemData]);

  useEffect(() => {
    if (oemData?.color) {
      const oemColor = oemData.color;
      document.documentElement.style.setProperty("--text-color", oemColor);
      document.documentElement.style.setProperty(
        "--text-color-op-10",
        hexToRGBA(oemColor, 0.1)
      );
      document.documentElement.style.setProperty(
        "--text-color-op-20",
        hexToRGBA(oemColor, 0.2)
      );
      document.documentElement.style.setProperty(
        "--text-color-op-40",
        hexToRGBA(oemColor, 0.4)
      );
    }
  }, [oemData]);

  // const isAuthenticating = useAuthCheck();
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorPrimary: oemData?.color,
            colorPrimaryHover: "white",
          },
        },
        token: {
          fontFamily: '"Poppins", sans-serif',
        },
      }}
    >
      <>
        <Router>
          <AutoLogout timeout={30 * 60 * 1000} />
          <Routes>
            {protectedRoutes.map((route, id) => (
              <Route
                key={id}
                path={route.path}
                element={<PrivateRoute children={route.element} />}
              />
            ))}

            <Route path="/" element={<Login />} />
            {/* <Route path="/signup" element={<Signup />} /> */}
            {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
            {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
            {/* <Route path="/initial" element={<CustomerLogin />} /> */}
            {/* <Route
              path="/setInitial"
              element={<InitialLicense type="initial" />}
            /> */}
            {/* <Route
              path="/setUpgrade"
              element={<InitialLicense type="upgrade" />}
            /> */}
            {/* <Route path="/newLicense" element={<LicenseUpgrade type="new" />} />*/}
            {/* <Route path="/newLicense" element={<UpgradedLicense />} /> */}
            {/* <Route path="/orderedItems" element={<OrderedItem />} /> */}
            {/* <Route
              path="/license/information/:id"
              element={<OrderedItemForm />}
            /> */}
            {/* <Route path="/upgrade" element={<CustomerLogin />} /> */}
            <Route path="/blocked" element={<BlockPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </>
    </ConfigProvider>
  );
}
export default App;
